import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

// This wrapper fixes react-beautiful-dnd compatibility issues with React 18
export function StrictModeDroppable(props) {
  const [enabled, setEnabled] = useState(false);
  
  useEffect(() => {
    // This timeout helps ensure we don't get the "Unable to find draggable" errors
    const animation = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);
  
  if (!enabled) {
    return null;
  }
  
  return <Droppable {...props} />;
}

export { DragDropContext, Draggable }; 